(function() {
  'use strict';

  // ============================================
  // HEADER - Sticky & Scroll Behavior
  // ============================================
  const header = document.querySelector('[data-header]');
  const announcementBar = document.getElementById('announcement-bar');
  const topbar = document.querySelector('.topbar');

  function handleScroll() {
    const scrollY = window.scrollY;

    if (header) {
      if (scrollY > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    if (announcementBar) {
      if (scrollY > 50) {
        announcementBar.style.transform = 'translateY(-100%)';
        announcementBar.style.position = 'absolute';
      } else {
        announcementBar.style.transform = 'translateY(0)';
        announcementBar.style.position = 'relative';
      }
    }

    if (topbar) {
      if (scrollY > 50) {
        topbar.style.height = '0';
        topbar.style.overflow = 'hidden';
        topbar.style.padding = '0';
        topbar.style.opacity = '0';
      } else {
        topbar.style.height = '';
        topbar.style.overflow = '';
        topbar.style.padding = '';
        topbar.style.opacity = '';
      }
    }

    // Back to top
    const backToTop = document.querySelector('[data-back-to-top]');
    if (backToTop) {
      if (scrollY > 400) {
        backToTop.classList.add('is-visible');
      } else {
        backToTop.classList.remove('is-visible');
      }
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Back to top click
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-back-to-top]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  // ============================================
  // MOBILE MENU
  // ============================================
  (function() {
    function openMobileMenu() {
      var menu = document.querySelector('[data-mobile-menu]');
      if (menu) {
        menu.classList.add('is-open');
        document.body.classList.add('mobile-menu-open');
      }
    }

    function closeMobileMenu() {
      var menu = document.querySelector('[data-mobile-menu]');
      if (menu) {
        menu.classList.remove('is-open');
        document.body.classList.remove('mobile-menu-open');
      }
    }

    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-mobile-menu-toggle]')) {
        openMobileMenu();
      }
      if (e.target.closest('[data-mobile-menu-close]')) {
        closeMobileMenu();
      }
      var expandBtn = e.target.closest('[data-mobile-expand]');
      if (expandBtn) {
        var item = expandBtn.closest('.mobile-menu__item');
        if (item) item.classList.toggle('is-expanded');
      }
    });
  })();

  // ============================================
  // CART DRAWER
  // ============================================
  document.addEventListener('click', function(e) {
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!cartDrawer) return;

    if (e.target.closest('[data-cart-toggle]')) {
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    if (e.target.closest('[data-cart-close]')) {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  // Cart quantity buttons
  document.addEventListener('click', function(e) {
    const minusBtn = e.target.closest('[data-qty-minus]');
    const plusBtn = e.target.closest('[data-qty-plus]');

    if (minusBtn) {
      const key = minusBtn.getAttribute('data-qty-minus');
      updateCartQuantity(key, -1);
    }

    if (plusBtn) {
      const key = plusBtn.getAttribute('data-qty-plus');
      updateCartQuantity(key, 1);
    }
  });

  function updateCartQuantity(key, change) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: change
      })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      window.location.reload();
    });
  }

  // Quick add to cart
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    e.preventDefault();
    const variantId = btn.getAttribute('data-quick-add');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: 1
      })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      var cartDrawer = document.querySelector('[data-cart-drawer]');
      if (cartDrawer) {
        cartDrawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      updateCartCount();
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var counts = document.querySelectorAll('[data-cart-count]');
        counts.forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
  }

  // ============================================
  // SEARCH OVERLAY
  // ============================================
  document.addEventListener('click', function(e) {
    var searchOverlay = document.querySelector('[data-search-overlay]');
    if (!searchOverlay) return;

    if (e.target.closest('[data-search-toggle]')) {
      searchOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var input = searchOverlay.querySelector('[data-search-input]');
      if (input) setTimeout(function() { input.focus(); }, 300);
    }

    if (e.target.closest('[data-search-close]')) {
      searchOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  // Predictive search
  var searchTimeout;
  document.addEventListener('input', function(e) {
    var input = e.target.closest('[data-search-input]');
    if (!input) return;

    clearTimeout(searchTimeout);
    var query = input.value.trim();
    var results = document.querySelector('[data-search-results]');

    if (query.length < 2) {
      if (results) results.innerHTML = '';
      return;
    }

    searchTimeout = setTimeout(function() {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!results) return;
          var products = data.resources.results.products || [];
          if (products.length === 0) {
            results.innerHTML = '<p class="search-overlay__no-results">No products found</p>';
            return;
          }
          var html = '<div class="search-overlay__products">';
          products.forEach(function(p) {
            html += '<a href="' + p.url + '" class="search-overlay__product">';
            if (p.image) {
              html += '<img src="' + p.image + '" alt="' + p.title + '" class="search-overlay__product-image" width="60" height="60">';
            }
            html += '<div class="search-overlay__product-info">';
            html += '<span class="search-overlay__product-title">' + p.title + '</span>';
            html += '<span class="search-overlay__product-price">' + p.price + '</span>';
            html += '</div></a>';
          });
          html += '</div>';
          results.innerHTML = html;
        });
    }, 300);
  });

  // ============================================
  // HERO SLIDESHOW
  // ============================================
  var slideshow = document.querySelector('[data-slideshow]');
  if (slideshow) {
    var slides = slideshow.querySelectorAll('[data-slide]');
    var dots = slideshow.querySelectorAll('[data-slide-dot]');
    var currentSlide = 0;
    var slideInterval;

    function goToSlide(index) {
      slides.forEach(function(s) { s.classList.remove('is-active'); });
      dots.forEach(function(d) { d.classList.remove('is-active'); });

      currentSlide = index;
      if (slides[currentSlide]) slides[currentSlide].classList.add('is-active');
      if (dots[currentSlide]) dots[currentSlide].classList.add('is-active');
    }

    function nextSlide() {
      goToSlide((currentSlide + 1) % slides.length);
    }

    function startAutoplay() {
      var speed = (parseInt(slideshow.closest('[data-slideshow]')?.dataset?.autoplaySpeed) || 5) * 1000;
      slideInterval = setInterval(nextSlide, speed);
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        clearInterval(slideInterval);
        goToSlide(parseInt(this.getAttribute('data-slide-dot')));
        startAutoplay();
      });
    });

    if (slides.length > 1) {
      startAutoplay();
    }
  }

  // ============================================
  // PRODUCT PAGE
  // ============================================

  // Thumbnail gallery
  document.addEventListener('mouseenter', function(e) {
    var thumb = e.target.closest('[data-thumb-index]');
    if (!thumb) return;

    var index = parseInt(thumb.getAttribute('data-thumb-index'));
    var gallery = thumb.closest('.product-page__gallery');
    if (!gallery) return;

    gallery.querySelectorAll('[data-thumb-index]').forEach(function(t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');

    gallery.querySelectorAll('[data-image-index]').forEach(function(img) {
      img.classList.remove('is-active');
    });
    var target = gallery.querySelector('[data-image-index="' + index + '"]');
    if (target) target.classList.add('is-active');
  }, true);

  // Image zoom
  document.addEventListener('mousemove', function(e) {
    var img = e.target.closest('.product-page__image--zoomable');
    if (!img) return;

    var rect = img.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;

    img.style.transformOrigin = x + '% ' + y + '%';
    img.style.transform = 'scale(2)';
  });

  document.addEventListener('mouseleave', function(e) {
    var img = e.target.closest('.product-page__image--zoomable');
    if (!img) return;

    img.style.transform = 'scale(1)';
  }, true);

  // Product form - Quantity
  document.addEventListener('click', function(e) {
    var form = e.target.closest('.product-form');
    if (!form) return;

    var input = form.querySelector('[data-quantity-input]');
    if (!input) return;

    if (e.target.closest('[data-qty-minus]')) {
      input.value = Math.max(1, parseInt(input.value) - 1);
    }
    if (e.target.closest('[data-qty-plus]')) {
      input.value = parseInt(input.value) + 1;
    }
  });

  // Product form - Option selection
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.product-form__option-btn');
    if (!btn || btn.classList.contains('is-disabled')) return;

    var optionName = btn.getAttribute('data-option-name');
    var optionValue = btn.getAttribute('data-option-value');
    var form = btn.closest('.product-form');
    if (!form) return;

    // Update active state
    btn.closest('.product-form__option-values').querySelectorAll('.product-form__option-btn').forEach(function(b) {
      b.classList.remove('is-active');
    });
    btn.classList.add('is-active');

    // Update label
    var label = form.querySelector('[data-option-value="' + optionName + '"]');
    if (label) label.textContent = optionValue;

    // Update variant select
    updateVariantSelect(form);
  });

  function updateVariantSelect(form) {
    var select = form.querySelector('[data-variant-select]');
    if (!select) return;

    var selectedOptions = [];
    form.querySelectorAll('.product-form__option-values').forEach(function(optGroup) {
      var active = optGroup.querySelector('.product-form__option-btn.is-active');
      if (active) {
        selectedOptions.push(active.getAttribute('data-option-value'));
      }
    });

    var selectedTitle = selectedOptions.join(' / ');
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].text.indexOf(selectedTitle) === 0) {
        select.selectedIndex = i;

        var option = select.options[i];
        var price = option.getAttribute('data-price');
        var comparePrice = option.getAttribute('data-compare-price');
        var available = !option.disabled;
        var variantId = option.value;
        var variantImage = option.getAttribute('data-variant-image');

        var infoSection = form.closest('.product-page__info') || form.closest('.product-page__grid') || document;

        var priceEl = infoSection.querySelector('.product-page__price');
        if (priceEl && price) priceEl.textContent = price;

        var comparePriceEl = infoSection.querySelector('.product-page__compare-price');
        if (comparePriceEl) {
          if (comparePrice) {
            comparePriceEl.textContent = comparePrice;
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        var addBtn = form.querySelector('.product-form__add-btn');
        if (addBtn) {
          addBtn.disabled = !available;
          addBtn.textContent = available ? (addBtn.getAttribute('data-add-text') || 'Add to Cart') : (addBtn.getAttribute('data-sold-text') || 'Sold Out');
        }

        var buyNowBtn = form.querySelector('[data-buy-now]');
        if (buyNowBtn) {
          buyNowBtn.style.display = available ? '' : 'none';
        }

        if (variantImage) {
          var slides = document.querySelectorAll('.product-page__image-slide');
          var thumbs = document.querySelectorAll('.product-page__thumbnail');
          slides.forEach(function(slide, idx) {
            var img = slide.querySelector('img');
            if (img) {
              var imgSrc = img.getAttribute('src') || '';
              var zoomSrc = img.getAttribute('data-zoom-src') || '';
              if (imgSrc.indexOf(variantImage) > -1 || variantImage.indexOf(imgSrc.split('?')[0]) > -1) {
                slides.forEach(function(s) { s.classList.remove('is-active'); });
                slide.classList.add('is-active');
                thumbs.forEach(function(t) { t.classList.remove('is-active'); });
                if (thumbs[idx]) thumbs[idx].classList.add('is-active');
              }
            }
          });
        }

        var pickupEl = document.querySelector('[data-pickup-availability]');
        if (pickupEl) {
          pickupEl.setAttribute('data-variant-id', variantId);
        }

        var paymentTermsEl = form.querySelector('shopify-payment-terms');
        if (paymentTermsEl) {
          paymentTermsEl.setAttribute('variant-id', variantId);
        }

        var stickyPrice = document.querySelector('.sticky-buy-bar__price');
        if (stickyPrice && price) stickyPrice.textContent = price;

        select.dispatchEvent(new Event('change', { bubbles: true }));

        break;
      }
    }
  }

  // Buy now button
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn) return;

    var form = btn.closest('.product-form');
    if (!form) return;

    var variantSelect = form.querySelector('[data-variant-select]');
    var quantityInput = form.querySelector('[data-quantity-input]');

    var variantId = variantSelect ? variantSelect.value : null;
    var quantity = quantityInput ? parseInt(quantityInput.value) : 1;

    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
    })
    .then(function() {
      window.location.href = '/checkout';
    });
  });

  // ============================================
  // PRODUCT TABS
  // ============================================
  document.addEventListener('click', function(e) {
    var tabBtn = e.target.closest('[data-tab-btn]');
    if (!tabBtn) return;

    var tabId = tabBtn.getAttribute('data-tab-btn');
    var tabs = tabBtn.closest('[data-product-tabs]');
    if (!tabs) return;

    tabs.querySelectorAll('[data-tab-btn]').forEach(function(b) {
      b.classList.remove('is-active');
    });
    tabBtn.classList.add('is-active');

    tabs.querySelectorAll('[data-tab-content]').forEach(function(c) {
      c.classList.remove('is-active');
    });
    var content = tabs.querySelector('[data-tab-content="' + tabId + '"]');
    if (content) content.classList.add('is-active');
  });

  // ============================================
  // QUICK VIEW MODAL
  // ============================================
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;

    e.preventDefault();
    var handle = btn.getAttribute('data-quick-view');
    var modal = document.querySelector('[data-quick-view].quick-view') || document.querySelector('.quick-view');
    if (!modal) return;

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var content = modal.querySelector('[data-quick-view-content]');
        if (!content) return;

        var html = '<div class="quick-view__grid">';
        html += '<div class="quick-view__image">';
        if (product.featured_image) {
          html += '<img src="' + product.featured_image + '" alt="' + product.title + '" width="400" height="400">';
        }
        html += '</div>';
        html += '<div class="quick-view__info">';
        html += '<h2 class="quick-view__title">' + product.title + '</h2>';
        html += '<p class="quick-view__price">' + Shopify.formatMoney(product.price) + '</p>';
        html += '<p class="quick-view__description">' + (product.description || '').replace(/<[^>]*>/g, '').substring(0, 200) + '</p>';
        html += '<a href="/products/' + product.handle + '" class="btn btn--primary btn--full">View Full Details</a>';
        html += '</div></div>';

        content.innerHTML = html;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-quick-view-close]')) {
      var modal = document.querySelector('.quick-view');
      if (modal) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

  // ============================================
  // COLLECTION PAGE
  // ============================================

  // Filter toggle
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-filter-toggle]');
    if (!btn) return;

    var sidebar = document.querySelector('[data-filter-sidebar]');
    if (!sidebar) return;

    sidebar.classList.toggle('is-visible');
    var text = btn.querySelector('[data-filter-text]');
    if (text) {
      text.textContent = sidebar.classList.contains('is-visible') ? 'Hide Filters' : 'Show Filters';
    }
  });

  // Sort select
  document.addEventListener('change', function(e) {
    var select = e.target.closest('[data-sort-select]');
    if (!select) return;

    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.href = url.toString();
  });

  // ============================================
  // TESTIMONIALS SLIDER
  // ============================================
  var testimonialsSection = document.querySelector('[data-testimonials]');
  if (testimonialsSection) {
    var tSlides = testimonialsSection.querySelectorAll('[data-testimonial]');
    var tDots = testimonialsSection.querySelectorAll('[data-testimonial-dot]');
    var tCurrent = 0;

    function goToTestimonial(index) {
      tSlides.forEach(function(s) { s.classList.remove('is-active'); });
      tDots.forEach(function(d) { d.classList.remove('is-active'); });
      tCurrent = index;
      if (tSlides[tCurrent]) tSlides[tCurrent].classList.add('is-active');
      if (tDots[tCurrent]) tDots[tCurrent].classList.add('is-active');
    }

    tDots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToTestimonial(parseInt(this.getAttribute('data-testimonial-dot')));
      });
    });

    var tPrev = testimonialsSection.querySelector('[data-testimonial-prev]');
    var tNext = testimonialsSection.querySelector('[data-testimonial-next]');
    if (tPrev) tPrev.addEventListener('click', function() {
      goToTestimonial((tCurrent - 1 + tSlides.length) % tSlides.length);
    });
    if (tNext) tNext.addEventListener('click', function() {
      goToTestimonial((tCurrent + 1) % tSlides.length);
    });
  }

  // ============================================
  // COUNTDOWN TIMER
  // ============================================
  var countdowns = document.querySelectorAll('[data-countdown]');
  countdowns.forEach(function(countdown) {
    var endDate = new Date(countdown.getAttribute('data-end-date')).getTime();
    var daysEl = countdown.querySelector('[data-countdown-days]');
    var hoursEl = countdown.querySelector('[data-countdown-hours]');
    var minutesEl = countdown.querySelector('[data-countdown-minutes]');
    var secondsEl = countdown.querySelector('[data-countdown-seconds]');

    function updateCountdown() {
      var now = new Date().getTime();
      var diff = endDate - now;

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });

  // ============================================
  // FAQ ACCORDION
  // ============================================
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-faq-toggle]');
    if (!toggle) return;

    var item = toggle.closest('[data-faq-item]');
    if (!item) return;

    var isOpen = item.classList.contains('is-open');
    
    // Close all other items in same FAQ section
    var faqSection = item.closest('.faq__list');
    if (faqSection) {
      faqSection.querySelectorAll('[data-faq-item]').forEach(function(i) {
        i.classList.remove('is-open');
        i.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
      });
    }

    if (!isOpen) {
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });

  // ============================================
  // VIDEO SECTION - Cover Image Play
  // ============================================
  document.addEventListener('click', function(e) {
    var playBtn = e.target.closest('[data-video-play]');
    if (!playBtn) return;

    var container = playBtn.closest('[data-video-container]');
    if (!container) return;

    var cover = container.querySelector('[data-video-cover]');
    var iframe = container.querySelector('[data-video-iframe]');

    if (cover) cover.style.display = 'none';
    if (iframe) {
      iframe.classList.remove('is-hidden');
      var src = iframe.getAttribute('data-video-src');
      if (src) iframe.src = src;
    }
  });

  // ============================================
  // SLIDESHOW SPLIT
  // ============================================
  var splitSlideshow = document.querySelector('[data-slideshow-split]');
  if (splitSlideshow) {
    var splitSlides = splitSlideshow.querySelectorAll('[data-split-slide]');
    var splitCurrent = 0;
    var splitCounter = splitSlideshow.querySelector('[data-split-current]');

    function goToSplitSlide(index) {
      splitSlides.forEach(function(s) { s.classList.remove('is-active'); });
      splitCurrent = index;
      if (splitSlides[splitCurrent]) splitSlides[splitCurrent].classList.add('is-active');
      if (splitCounter) splitCounter.textContent = splitCurrent + 1;
    }

    var splitPrev = splitSlideshow.querySelector('[data-split-prev]');
    var splitNext = splitSlideshow.querySelector('[data-split-next]');
    if (splitPrev) splitPrev.addEventListener('click', function() {
      goToSplitSlide((splitCurrent - 1 + splitSlides.length) % splitSlides.length);
    });
    if (splitNext) splitNext.addEventListener('click', function() {
      goToSplitSlide((splitCurrent + 1) % splitSlides.length);
    });
  }

  // ============================================
  // BEFORE / AFTER SLIDER
  // ============================================
  var baContainers = document.querySelectorAll('[data-before-after]');
  baContainers.forEach(function(container) {
    var slider = container.querySelector('[data-before-after-slider]');
    var overlay = container.querySelector('[data-before-after-overlay]');
    if (!slider || !overlay) return;

    var isDragging = false;

    function updateSlider(x) {
      var rect = container.getBoundingClientRect();
      var percent = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
      overlay.style.width = percent + '%';
      slider.style.left = percent + '%';
    }

    slider.addEventListener('mousedown', function(e) {
      isDragging = true;
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      updateSlider(e.clientX);
    });
    document.addEventListener('mouseup', function() {
      isDragging = false;
    });

    slider.addEventListener('touchstart', function(e) {
      isDragging = true;
    }, { passive: true });
    document.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      updateSlider(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchend', function() {
      isDragging = false;
    });
  });

  // ============================================
  // LOOKBOOK HOTSPOTS
  // ============================================
  document.addEventListener('click', function(e) {
    var hotspot = e.target.closest('[data-hotspot]');
    if (!hotspot) return;

    // Close all other hotspot cards
    document.querySelectorAll('[data-hotspot].is-active').forEach(function(h) {
      if (h !== hotspot) h.classList.remove('is-active');
    });

    hotspot.classList.toggle('is-active');
  });

  // Close hotspots when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-hotspot]')) {
      document.querySelectorAll('[data-hotspot].is-active').forEach(function(h) {
        h.classList.remove('is-active');
      });
    }
  });

  // ============================================
  // PROMO POPUP
  // ============================================
  var promoPopup = document.querySelector('[data-promo-popup]');
  if (promoPopup) {
    var delay = parseInt(promoPopup.getAttribute('data-delay')) || 5;
    var popupDismissed = sessionStorage.getItem('shoonya_popup_dismissed');

    if (!popupDismissed) {
      setTimeout(function() {
        promoPopup.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }, delay * 1000);
    }

    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-promo-close]')) {
        promoPopup.classList.remove('is-open');
        document.body.style.overflow = '';
        sessionStorage.setItem('shoonya_popup_dismissed', 'true');
      }
    });
  }

  // ============================================
  // RECENTLY VIEWED PRODUCTS
  // ============================================
  (function() {
    var STORAGE_KEY = 'shoonya_recently_viewed';
    var MAX_ITEMS = 8;

    // Track current product
    if (window.location.pathname.indexOf('/products/') === 0) {
      var handle = window.location.pathname.split('/products/')[1].split('?')[0].split('#')[0];
      if (handle) {
        var viewed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        viewed = viewed.filter(function(h) { return h !== handle; });
        viewed.unshift(handle);
        viewed = viewed.slice(0, MAX_ITEMS);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
      }
    }

    // Render recently viewed
    var rvGrid = document.querySelector('[data-recently-viewed-grid]');
    var rvSection = document.querySelector('[data-recently-viewed]');
    if (rvGrid && rvSection) {
      var viewed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (viewed.length === 0) {
        rvSection.style.display = 'none';
        return;
      }

      var limit = parseInt(rvSection.querySelector('[data-recently-viewed-grid]')?.closest('section')?.dataset?.productsToShow) || 4;
      var handles = viewed.slice(0, limit);

      Promise.all(handles.map(function(h) {
        return fetch('/products/' + h + '.js').then(function(r) { return r.json(); }).catch(function() { return null; });
      })).then(function(products) {
        var html = '';
        products.forEach(function(p) {
          if (!p) return;
          html += '<div class="product-card">';
          html += '<a href="/products/' + p.handle + '" class="product-card__image-wrapper">';
          html += '<div class="product-card__image-container">';
          if (p.featured_image) {
            html += '<img src="' + p.featured_image + '" alt="' + p.title + '" class="product-card__image product-card__image--primary" loading="lazy">';
          }
          html += '</div></a>';
          html += '<div class="product-card__info">';
          html += '<a href="/products/' + p.handle + '" class="product-card__title">' + p.title + '</a>';
          html += '<div class="product-card__price"><span class="product-card__price--current">' + Shopify.formatMoney(p.price) + '</span></div>';
          html += '</div></div>';
        });
        rvGrid.innerHTML = html;
      });
    }
  })();

  // ============================================
  // ANNOUNCEMENT BAR SLIDER
  // ============================================
  (function() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    var items = bar.querySelectorAll('[data-announcement-item]');
    if (items.length <= 1) return;

    var currentIndex = 0;
    var autoRotate = bar.getAttribute('data-auto-rotate') === 'true';
    var speed = parseInt(bar.getAttribute('data-speed')) || 5;
    var timer = null;

    function showSlide(index) {
      items.forEach(function(item) { item.classList.remove('is-active'); });
      items[index].classList.add('is-active');
    }

    function nextSlide() {
      currentIndex = (currentIndex + 1) % items.length;
      showSlide(currentIndex);
    }

    function prevSlide() {
      currentIndex = (currentIndex - 1 + items.length) % items.length;
      showSlide(currentIndex);
    }

    function startAutoRotate() {
      if (autoRotate && items.length > 1) {
        timer = setInterval(nextSlide, speed * 1000);
      }
    }

    function stopAutoRotate() {
      if (timer) clearInterval(timer);
    }

    var prevBtn = bar.querySelector('[data-announcement-prev]');
    var nextBtn = bar.querySelector('[data-announcement-next]');

    if (prevBtn) prevBtn.addEventListener('click', function() {
      stopAutoRotate();
      prevSlide();
      startAutoRotate();
    });

    if (nextBtn) nextBtn.addEventListener('click', function() {
      stopAutoRotate();
      nextSlide();
      startAutoRotate();
    });

    startAutoRotate();
  })();

  // ANNOUNCEMENT BAR CLOSE
  // ============================================
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('[data-announcement-close]');
    if (!closeBtn) return;

    var bar = closeBtn.closest('.announcement-bar');
    if (bar) {
      bar.style.display = 'none';
      sessionStorage.setItem('shoonya_announcement_closed', 'true');
    }
  });

  if (sessionStorage.getItem('shoonya_announcement_closed')) {
    var bar = document.querySelector('[data-announcement-bar]');
    if (bar) bar.style.display = 'none';
  }

  // ============================================
  // PICKUP AVAILABILITY TOGGLE
  // ============================================
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-pickup-availability-toggle]');
    if (!toggle) return;
    var list = toggle.parentElement.querySelector('[data-pickup-availability-list]');
    if (list) {
      var isHidden = list.style.display === 'none';
      list.style.display = isHidden ? 'block' : 'none';
      toggle.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
    }
  });

  // ============================================
  // STICKY BUY NOW BAR
  // ============================================
  (function() {
    var stickyBar = document.querySelector('[data-sticky-buy]');
    if (!stickyBar) return;

    var addBtn = document.querySelector('.product-form__add-btn');
    if (!addBtn) return;

    var threshold = 0;
    function updateThreshold() {
      var rect = addBtn.getBoundingClientRect();
      threshold = rect.bottom + window.pageYOffset;
    }

    updateThreshold();
    window.addEventListener('resize', updateThreshold);
    window.addEventListener('load', updateThreshold);

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (window.pageYOffset > threshold) {
            stickyBar.classList.add('is-visible');
          } else {
            stickyBar.classList.remove('is-visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    });

    var buyBtn = stickyBar.querySelector('[data-sticky-buy-btn]');
    if (buyBtn) {
      buyBtn.addEventListener('click', function() {
        if (addBtn && !addBtn.disabled) {
          addBtn.click();
        }
      });
    }
  })();

  // ============================================
  // INSTAGRAM CAROUSEL
  // ============================================
  (function() {
    var carousels = document.querySelectorAll('[data-instagram-carousel]');
    carousels.forEach(function(section) {
      var track = section.querySelector('[data-carousel-track]');
      var prevBtn = section.querySelector('[data-carousel-prev]');
      var nextBtn = section.querySelector('[data-carousel-next]');
      var dotsContainer = section.querySelector('[data-carousel-dots]');
      if (!track) return;

      var slides = track.children;
      var currentIndex = 0;
      var autoplayInterval = null;
      var autoplay = section.getAttribute('data-autoplay') !== 'false';
      var speed = (parseInt(section.getAttribute('data-autoplay-speed')) || 4) * 1000;
      var slidesDesktop = parseInt(section.getAttribute('data-slides-desktop')) || 5;
      var slidesMobile = parseInt(section.getAttribute('data-slides-mobile')) || 2;

      function getSlidesPerView() {
        var w = window.innerWidth;
        if (w < 768) return slidesMobile;
        if (w < 1024) return Math.min(slidesDesktop, 4);
        return slidesDesktop;
      }

      function getMaxIndex() {
        return Math.max(0, slides.length - getSlidesPerView());
      }

      function updateSlideWidths() {
        var spv = getSlidesPerView();
        var pct = (100 / spv) + '%';
        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = pct;
        }
      }

      function buildDots() {
        if (!dotsContainer) return;
        var maxIdx = getMaxIndex();
        dotsContainer.innerHTML = '';
        for (var i = 0; i <= maxIdx; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'instagram-feed__dot' + (i === currentIndex ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.setAttribute('data-dot-index', i);
          (function(idx) {
            dot.addEventListener('click', function() {
              goTo(idx);
              startAutoplay();
            });
          })(i);
          dotsContainer.appendChild(dot);
        }
      }

      function goTo(index) {
        var maxIdx = getMaxIndex();
        currentIndex = Math.max(0, Math.min(index, maxIdx));
        var slideWidth = 100 / getSlidesPerView();
        track.style.transform = 'translateX(-' + (currentIndex * slideWidth) + '%)';

        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('[data-dot-index]');
          dots.forEach(function(dot, i) {
            dot.classList.toggle('is-active', i === currentIndex);
          });
        }
      }

      function goNext() {
        goTo(currentIndex >= getMaxIndex() ? 0 : currentIndex + 1);
      }

      function goPrev() {
        goTo(currentIndex <= 0 ? getMaxIndex() : currentIndex - 1);
      }

      function startAutoplay() {
        stopAutoplay();
        if (autoplay) {
          autoplayInterval = setInterval(goNext, speed);
        }
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goPrev(); startAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goNext(); startAutoplay(); });

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);

      window.addEventListener('resize', function() {
        updateSlideWidths();
        buildDots();
        goTo(currentIndex);
      });

      updateSlideWidths();
      buildDots();
      goTo(0);
      startAutoplay();
    });
  })();

  // ============================================
  // SHOPIFY MONEY FORMAT HELPER
  // ============================================
  if (typeof Shopify === 'undefined') {
    window.Shopify = {};
  }
  if (!Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var value = (parseInt(cents) / 100).toFixed(2);
      var moneyFormat = format || (window.theme && window.theme.moneyFormat) || '£{{amount}}';
      return moneyFormat.replace('{{amount}}', value).replace('{{amount_no_decimals}}', Math.round(value));
    };
  }

})();
